export default __webpack_public_path__ + "6c669ed5b5dd9a052ada54faa534f60d.png";